import Filter from "../Filter/Filter";
import Input from "../Input-new/Input";
import React from "react";
import SelectMultiTenantFilter from "../SelectMultiTenantFilter";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import SelectAgent from "../SelectAgent/SelectAgent";
import SelectFirm from "../SelectFirm/SelectFirm";
import Checkbox from "../CheckboxNew";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";
import TerritoryTeam from "../TerritoryTeam/TerritoryTeam";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL, isAgentUser, groupObjectByIndex } from "../../utils";
import territory, { flattenedTerritories, flattenedTerritoriesCombinations, getMarketOptions, getMarketOptionsCombinations, getTerritoriesOptions, getTerritoriesOptionsCombinations, marketOptionsCombinations } from "../../territory";
import territoryProductType from "../../territory-product-type";
import territoryMarket from "../../territory-market";
import Icon from "../Icon/Icon";
import trash from '../../svgs/Trash.svg'
import RecordGroupFilterDropdown from "../RecordGroups/RecordGroupFilterDropdown";

export default class ListingFilter extends Filter {
    constructor(props) {
        super(props);
    }
    
    render() {
        const {query, buyerStateBreakdownCheckbox, transactionBreakdownCheckbox, marketTransactionBreakdownCheckbox, marketShareCheckbox} = this.state;
        const isTransactionBreakdown = transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox;
        const isFinancing = query && query.source === 'HSC';
        
          function reindexGroupedKeys(obj) {
            const result = {};
            const grouped = {};
          
            // Allowed keys we want to reindex together
            const allowed = ["product_type", "territory_market", "territory"];
          
            // Group by suffix index
            Object.entries(obj).forEach(([key, value]) => {
              const match = key.match(/^(\w+?)_(\d+)$/);
              if (match) {
                const base = match[1];
                const index = match[2];
          
                if (allowed.includes(base)) {
                  if (!grouped[index]) grouped[index] = {};
                  grouped[index][base] = value;
                } else {
                  // Non-allowed keys stay as they are
                  result[key] = value;
                }
              } else {
                result[key] = value;
              }
            });
          
            // Sort indices numerically and rebuild with new sequential indices
            const sortedIndices = Object.keys(grouped).sort((a, b) => a - b);
          
            sortedIndices.forEach((_, newIdx) => {
              const newIndex = newIdx + 1; // start from 1
              const values = grouped[sortedIndices[newIdx]];
              for (const base in values) {
                result[`${base}_${newIndex}`] = values[base];
              }
            });
          
            return result;
          }
          
        const panes = [
            (
                <div className='Filter_wrapper'>
                    <h3>Property Info</h3>
                    <RecordGroupFilterDropdown
                      theme='dark'
                      groupType='property'
                      ownerAgentId={this.props.userData && this.props.userData.id}
                      value={query.group_id}
                      valueKey='group_id'
                      label='Property Group'
                      data={query}
                      disabled={isTransactionBreakdown}
                      handleParentChange={this.handleDropdownChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='name'
                           label='Property Name'
                           value={query.name}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='address'
                           label='Address'
                           value={query.address}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Input theme='dark'
                           valueType='text'
                           name='city'
                           label='City'
                           value={query.city}
                           disabled={isTransactionBreakdown}
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown dropdownType='multiple'
                                theme='dark'
                                optionsType='states'
                                optionKey='abbr'
                                optionLabelKey='name'
                                value={query.state}
                                valueKey='state'
                                label='State'
                                data={query}
                                disabled={isTransactionBreakdown}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                
                    <Input theme='dark'
                            valueType='text'
                            name='zip'
                            label='Zip'
                            value={query.zip}
                            disabled={isTransactionBreakdown}
                            handleParentChange={this.handleChange}
                    />
                    <Dropdown dropdownType='multiple'
                              theme='dark'
                              optionsType='market'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.market}
                              valueKey='market'
                              label='Market'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        isFinancing ?
                            <Dropdown dropdownType='multiple'
                                      theme='dark'
                                      optionsType='status-financing'
                                      value={query.hsc_status}
                                      valueKey='hsc_status'
                                      label='Status'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                            :
                            <Dropdown dropdownType='multiple'
                                      theme='dark'
                                      optionsType='status'
                                      optionKey='code'
                                      value={query.status}
                                      valueKey='status'
                                      label='Status'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                    }
                    <Dropdown theme='dark'
                              optionsType='source'
                              value={query.source}
                              valueKey='source'
                              label='Source'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                              optionKey='code'
                              optionLabelKey='name'
                    />
                    <Dropdown theme='dark'
                              optionsType='transaction'
                              value={query.transaction_type}
                              valueKey='transaction_type'
                              label='transaction Type'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown dropdownType='multiple'
                              theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.category}
                              valueKey='category'
                              label='Category'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                     {query.category=='apartments' && <Dropdown
                             theme='dark'
                            optionKey="code"
                            optionLabelKey="name"
                            data={query}
                            isFromProperty
                            optionsType="subcategory"
                            value={query.sub_category}
                            valueKey="sub_category"
                            label="Sub Category"
                            disabled={isTransactionBreakdown}
                            handleParentChange={this.handleDropdownChange}                           
                        />}
                        
                    {query.category!='apartments' && <Dropdown theme='dark'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.type}
                              valueKey='type'
                              label='Type'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    /> }
                    {
                        query.type=== "STNL" && 
                        <React.Fragment>
                        {
                            getTenantSubcategorySTNL({data : query, handleChangeDropdown : this.handleDropdownChange, theme : 'dark', disabled:isTransactionBreakdown, isFilter:true}) 
                        } 
                            <Dropdown 
                                theme='dark'
                                optionsType='lease'
                                value={query.lease_type}
                                valueKey='lease_type'
                                label='Lease Type'
                                data={query}
                                disabled={isTransactionBreakdown}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                            />
                        </React.Fragment>
                    }
                    {
                        query.type=== "MT" && getTenantSubcategoryMT({data : query, handleChangeDropdown : this.handleDropdownChange, theme : 'dark',disabled:isTransactionBreakdown, isFilter:true})
                    }   
                    {
                        query.type === 'MT' &&
                        <SelectMultiTenantFilter theme='dark'
                                                    optionsType='tenant'
                                                    value={query.tenant_id}
                                                    valueKey='tenant_id'
                                                    label='Tenant'
                                                    data={query}
                                                    disabled={isTransactionBreakdown}
                                                    isFilter
                                                    handleParentChange={this.handleDropdownChange}
                        />
                    }
                    {query.category=='apartments' && <DualRange theme='dark'
                               minValue={query.units_min}
                               maxValue={query.units_max}
                               minName='units_min'
                               maxName='units_max'
                               valueType='integer'
                               label='# of Units'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />}
                    {query.category!='apartments' && <DualRange theme='dark'
                               minValue={query.sqft_min}
                               maxValue={query.sqft_max}
                               minName='sqft_min'
                               maxName='sqft_max'
                               valueType='integer'
                               label='Square Feet'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    /> }

                    

                   
                    <DualRange theme='dark'
                               minValue={query.lot_size_min}
                               maxValue={query.lot_size_max}
                               minName='lot_size_min'
                               maxName='lot_size_max'
                               valueType='integer'
                               label='Lot Size'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.year_built_min}
                               maxValue={query.year_built_max}
                               minName='year_built_min'
                               maxName='year_built_max'
                               valueType='number'
                               label='Year Built'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>Property Stats</h3>
                    <DualRange theme='dark'
                               minValue={query.list_price_min}
                               maxValue={query.list_price_max}
                               minName='list_price_min'
                               maxName='list_price_max'
                               valueType='integer'
                               label='List Price'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.capitalization_rate_min}
                               maxValue={query.capitalization_rate_max}
                               minName='capitalization_rate_min'
                               maxName='capitalization_rate_max'
                               valueType='percent'
                               label='List Cap Rate'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.price_per_sqft_min}
                               maxValue={query.price_per_sqft_max}
                               minName='price_per_sqft_min'
                               maxName='price_per_sqft_max'
                               valueType='integer'
                               label='Price Per Square Foot'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.sold_price_min}
                               maxValue={query.sold_price_max}
                               minName='sold_price_min'
                               maxName='sold_price_max'
                               valueType='integer'
                               label='Price at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.close_cap_rate_min}
                               maxValue={query.close_cap_rate_max}
                               minName='close_cap_rate_min'
                               maxName='close_cap_rate_max'
                               valueType='percent'
                               label='Cap Rate at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.close_price_per_sqft_min}
                               maxValue={query.close_price_per_sqft_max}
                               minName='close_price_per_sqft_min'
                               maxName='close_price_per_sqft_max'
                               valueType='integer'
                               label='Price Per Square Foot at Close'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.net_operating_income_min}
                               maxValue={query.net_operating_income_max}
                               minName='net_operating_income_min'
                               maxName='net_operating_income_max'
                               valueType='integer'
                               label='Net Operating Income'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.occupancy_min}
                               maxValue={query.occupancy_max}
                               minName='occupancy_min'
                               maxName='occupancy_max'
                               valueType='percent'
                               label='Occupancy'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.lease_expiration_date_min}
                               maxValue={query.lease_expiration_date_max}
                               minName='lease_expiration_date_min'
                               maxName='lease_expiration_date_max'
                               valueType='date'
                               label='Remaining Term'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.close_of_escrow_min}
                               maxValue={query.close_of_escrow_max}
                               minName='close_of_escrow_min'
                               maxName='close_of_escrow_max'
                               valueType='date'
                               label='Close of Escrow'
                               disabled={buyerStateBreakdownCheckbox || isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={query.listed_date_min}
                               maxValue={query.listed_date_max}
                               minName='listed_date_min'
                               maxName='listed_date_max'
                               valueType='date'
                               label='Date Listed'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (
                <div className='Filter_wrapper'>
                    <h3>Buyer / Seller</h3>
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.seller_company_state}
                              valueKey='seller_company_state'
                              label='Seller State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <SelectTeam theme='dark'
                                value={query.listing_agent_team}
                                valueKey='listing_agent_team'
                                label='STRIVE TEAM MEMBER'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                onlyActive={true}
                                handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.listing_agent_4}
                                 valueKey='listing_agent_4'
                                 label='LISTING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.listing_agent_4_firm}
                                valueKey='listing_agent_4_firm'
                                label='LISTING AGENT COMPANY'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='states'
                              optionKey='abbr'
                              optionLabelKey='name'
                              value={query.buyer_company_state}
                              valueKey='buyer_company_state'
                              label='Buyer State'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <SelectAgent theme='dark'
                                 value={query.buyer_agent_4}
                                 valueKey='buyer_agent_4'
                                 label='BUYING AGENT'
                                 disabled={isTransactionBreakdown}
                                 data={query}
                                 isFilter
                                 handleParentChange={this.handleDropdownChange}
                    />
                    <SelectFirm theme='dark'
                                value={query.buyer_agent_4_firm}
                                valueKey='buyer_agent_4_firm'
                                label='BUYING AGENT Company'
                                disabled={isTransactionBreakdown}
                                data={query}
                                isFilter
                                handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
            (
                <div>
                    <h3>MISC</h3>
                    <DualRange theme='dark'
                               minValue={query.date_created_min}
                               maxValue={query.date_created_max}
                               minName='date_created_min'
                               maxName='date_created_max'
                               valueType='date'
                               label='Date Created'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='superUsers'
                              value={query.created_by}
                              valueKey='created_by'
                              label='Created By'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                              client = {this.props.client}
                    />
                    <DualRange theme='dark'
                               minValue={query.last_modified_min}
                               maxValue={query.last_modified_max}
                               minName='last_modified_min'
                               maxName='last_modified_max'
                               valueType='date'
                               label='Last Modified'
                               disabled={isTransactionBreakdown}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='superUsers'
                              value={query.modified_by}
                              valueKey='modified_by'
                              label='Modified By'
                              data={query}
                              disabled={isTransactionBreakdown}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                              client = {this.props.client}
                    />
                    <Dropdown theme='dark'
                              optionsType='filters'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.empty}
                              valueKey='empty'
                              label='Empty'
                              data={query}
                              disabled={isTransactionBreakdown || buyerStateBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <div className='Filter_checkboxes'>
                        <div className='Filter_checkboxes_slider'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.strive_slider}
                                      valueKey='strive_slider'
                                      label='STRIVE Slider'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_checkboxes_featured'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.featured}
                                      valueKey='featured'
                                      label='Featured'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                        <div className='Filter_checkboxes_visible'>
                            <Dropdown theme='dark'
                                      optionsType='checkbox'
                                      optionKey='code'
                                      optionLabelKey='name'
                                      value={query.visible}
                                      valueKey='visible'
                                      label='Visible'
                                      data={query}
                                      disabled={isTransactionBreakdown}
                                      isFilter
                                      handleParentChange={this.handleDropdownChange}
                            />
                        </div>
                    </div>
                </div>
            ),(
                <div className='Filter_wrapper'>
                    <h3>AthCap</h3>
                    <DualRange theme='dark'
                        minValue={query.loan_closing_date_min}
                        maxValue={query.loan_closing_date_max}
                        minName='loan_closing_date_min'
                        maxName='loan_closing_date_max'
                        valueType='date'
                        label='Loan Closing Date'
                        disabled={isTransactionBreakdown}
                        handleParentChange={this.handleChange}
                    />
                </div>
            ),
            (                
                <div className='Filter_wrapper'>
                    <h3>Territories</h3>
                    <TerritoryTeam theme='dark'
                        value={query.territory_listing_agent_team} 
                        valueKey='territory_listing_agent_team'
                        label='STRIVE Agent'
                        disabled={isTransactionBreakdown}
                        data={query}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                        items={this.state.items}
                    />
                    <div>
                    {groupObjectByIndex(query) && groupObjectByIndex(query).map((val, idx)=>{
                        const product_type = `product_type_${idx+1}`;
                        const territory_market = `territory_market_${idx+1}`; 
                        const territory = `territory_${idx+1}`;
                        return (<div key={idx} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '8px'}}>
                        <Dropdown
                            theme='dark'
                            data={query}
                            options={territoryProductType}
                            value={query[product_type]}
                            valueKey={product_type}
                            label="Product Type"
                            handleParentChange={this.handleDropdownChange}
                            isFilter
                            optionsType="productType"
                            optionLabelKey='name'
                            optionKey='code'
                            disabled={query.hasOwnProperty('territory_listing_agent_team')}
                        />
                        <Dropdown 
                            theme='dark'
                            data={query}
                            optionLabelKey='name'
                            optionKey='code'
                            options={getMarketOptions(query, product_type)||[]}
                            value={query[territory_market]}
                            valueKey={territory_market}
                            label="Market"
                            handleParentChange={this.handleDropdownChange}
                            isFilter
                            optionsType="territoryMarket"
                            disabled={query.hasOwnProperty('territory_listing_agent_team')}
                        />
                        <Dropdown
                            theme='dark'
                            data={query}
                            optionKey='code'
                            optionLabelKey='name'
                            options={getTerritoriesOptions(query, product_type, territory_market)|| []}
                            value={query[territory]}
                            valueKey={territory}
                            label="Territory"
                            handleParentChange={this.handleDropdownChange}
                            isFilter
                            optionsType="territory"
                            disabled={query.hasOwnProperty('territory_listing_agent_team')}
                        />
                         {!query.hasOwnProperty('territory_listing_agent_team') && <Icon svg={trash} style={{ display: 'inline'}} onClick={()=>{
                                delete query[product_type];
                                delete query[territory_market];
                                delete query[territory];
                                let newQuery = reindexGroupedKeys(query);
                                this.setState({query: {...newQuery}})
                            }}/>}
                    </div>)})}
                    <button type="button" style={{marginBottom: '16px'}} className='button-new positive' onClick={()=>{
                        let next = groupObjectByIndex(query).length
                        let additionalQuery = {
                            [`product_type_${next + 1}`]: '',
                            [`territory_market_${next + 1}`]: '',
                            [`territory_${next + 1}`]: '',
                        }
                       this.setState({
                                query: {
                                    ...this.state.query,
                                    ...additionalQuery
                                }
                            })}}>Add</button>
                    </div>
                    <Dropdown dropdownType='multiple'
                        theme='dark'
                        optionsType='status'
                        optionKey='code'
                        value={query.status}
                        valueKey='status'
                        label='Status'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                        optionsType='transaction'
                        value={query.transaction_type}
                        valueKey='transaction_type'
                        label='transaction Type'
                        data={query}
                        disabled={isTransactionBreakdown}
                        isFilter
                        handleParentChange={this.handleDropdownChange}
                    />
                    {(query.status && query.status.includes('Closed')) &&
                        <DualRange theme='dark'
                                minValue={query.close_of_escrow_min}
                                maxValue={query.close_of_escrow_max}
                                minName='close_of_escrow_min'
                                maxName='close_of_escrow_max'
                                valueType='date'
                                label='Close of Escrow'
                                disabled={buyerStateBreakdownCheckbox || isTransactionBreakdown}
                                handleParentChange={this.handleChange}
                        />
                    }
                    {(query.status && query.status.includes('Active')) &&
                        <DualRange theme='dark'
                                minValue={query.listed_date_min}
                                maxValue={query.list_price_max}
                                minName='listed_date_min'
                                maxName='list_price_max'
                                valueType='date'
                                label='Date Listed'
                                disabled={isTransactionBreakdown}
                                handleParentChange={this.handleChange}
                        />
                    }
                </div>
            ),
            (
                <div>
                    <h3>Reports</h3>
                    <Checkbox darkMode
                              text='Buyer State Breakdown'
                              type={isTransactionBreakdown ? 'uncheckable' : 'checkable'}
                              name='buyerStateBreakdownCheckbox'
                              isSelected={buyerStateBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <DualRange theme='dark'
                               minValue={buyerStateBreakdownCheckbox ? query.base_min : ''}
                               maxValue={buyerStateBreakdownCheckbox ? query.base_max : ''}
                               minName='base_min'
                               maxName='base_max'
                               valueType='date'
                               label='Base'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={buyerStateBreakdownCheckbox ? query.comparison_min : ''}
                               maxValue={buyerStateBreakdownCheckbox ? query.comparison_max : ''}
                               minName='comparison_min'
                               maxName='comparison_max'
                               valueType='date'
                               label='Comparison'
                               disabled={!buyerStateBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />

                    <Checkbox darkMode
                              text='Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || marketTransactionBreakdownCheckbox || marketShareCheckbox ? 'uncheckable' : 'checkable'}
                              name='transactionBreakdownCheckbox'
                              isSelected={transactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Input theme='dark'
                           valueType='number'
                           name='transaction_year'
                           label='Transaction Year'
                           value={query.transaction_year}
                           disabled={!transactionBreakdownCheckbox}
                           placeholder='YYYY'
                           handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='type'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.type}
                              valueKey='type'
                              label='Type'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    {
                        query.type === 'MT' && transactionBreakdownCheckbox &&
                        <React.Fragment>
                            <DualRange theme='dark'
                                       minValue={query.sold_price_min}
                                       maxValue={query.sold_price_max}
                                       minName='sold_price_min'
                                       maxName='sold_price_max'
                                       valueType='integer'
                                       label='Sale Price'
                                       handleParentChange={this.handleChange}
                            />
                            <DualRange theme='dark'
                                       minValue={query.sqft_min}
                                       maxValue={query.sqft_max}
                                       minName='sqft_min'
                                       maxName='sqft_max'
                                       valueType='integer'
                                       label='Size'
                                       handleParentChange={this.handleChange}
                            />
                        </React.Fragment>
                    }
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.category}
                              valueKey='category'
                              label='Category'
                              data={query}
                              disabled={!transactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />

                    <Checkbox darkMode
                              text='Market Transaction Breakdown'
                              type={buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketShareCheckbox ? 'uncheckable' : 'checkable'}
                              name='marketTransactionBreakdownCheckbox'
                              isSelected={marketTransactionBreakdownCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />

                    <DualRange theme='dark'
                               minValue={marketTransactionBreakdownCheckbox ? query.base_min : ''}
                               maxValue={marketTransactionBreakdownCheckbox ? query.base_max : ''}
                               minName='base_min'
                               maxName='base_max'
                               valueType='date'
                               label='Base'
                               disabled={!marketTransactionBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <DualRange theme='dark'
                               minValue={marketTransactionBreakdownCheckbox ? query.comparison_min : ''}
                               maxValue={marketTransactionBreakdownCheckbox ? query.comparison_max : ''}
                               minName='comparison_min'
                               maxName='comparison_max'
                               valueType='date'
                               label='Comparison'
                               disabled={!marketTransactionBreakdownCheckbox}
                               handleParentChange={this.handleChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.category}
                              valueKey='category'
                              label='Category'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                            //   optionsType='market'
                            //   value={query.market}
                            //   valueKey='market'
                            //   label='Mark
                              optionsType='market'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.market}
                              valueKey='market'
                              label='Market'
                              data={query}
                              disabled={!marketTransactionBreakdownCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Checkbox darkMode
                              text='Market Share Report'
                              type={buyerStateBreakdownCheckbox || transactionBreakdownCheckbox || marketTransactionBreakdownCheckbox ? 'uncheckable' : 'checkable'}
                              name='marketShareCheckbox'
                              isSelected={marketShareCheckbox}
                              handleClick={this.handleBreakdownChange}
                    />
                    <Dropdown theme='dark'
                              optionsType='category'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.category}
                              valueKey='category'
                              label='Category'
                              data={query}
                              disabled={!marketShareCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                    <Dropdown theme='dark'
                            //   optionsType='market'
                            //   value={query.market}
                            //   valueKey='market'
                            //   label='Market'
                              optionsType='market'
                              optionKey='code'
                              optionLabelKey='name'
                              value={query.market}
                              valueKey='market'
                              label='Market'
                              data={query}
                              disabled={!marketShareCheckbox}
                              isFilter
                              handleParentChange={this.handleDropdownChange}
                    />
                </div>
            ),
        ];

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {React.cloneElement(this.props.children, {isSuper: this.props.isSuper, isSeniorAgent: this.props.isSeniorAgent,isAgent: this.props.isAgent, userData: this.props.userData})}
                </div>
                <SearchPanel ref='searchPanel' class="properties-top">
                    <form onSubmit={this.handleSubmit}>
                        <nav className='Filter_nav'>
                            <div className='Filter_button list' onClick={() => this.navigateTo('/list')}>List</div>
                            <div className='Filter_button' onClick={() => this.navigateTo('/map')}>Map</div>
                            <div className='Filter_button' onClick={this.close}>Close</div>
                        </nav>
                        <div className='Filter_slider'>
                            {panes.map((el, key) => (
                                <Control key={key} onClick={()=> this.handlePaneChange(key)}>
                                    <div className={'Filter_slider_icon'+(key === this.state.paneIndex ? ' Filter_slider_icon--active' : '')}/>
                                </Control>
                            ))}
                        </div>
                        {panes[this.state.paneIndex]}
                        <div className='Filter_buttons'>
                            <button type='button'  style={{opacity:(isAgentUser(this.props.userData)) ? 0.5 : 1,}} disabled={isAgentUser(this.props.userData)} className='button-new negative dark' onClick={this.clear}>Clear</button>
                            <button style={{opacity:(isAgentUser(this.props.userData)) ? 0.5 : 1,}} disabled={isAgentUser(this.props.userData)} className='button-new positive'>Apply</button>
                        </div>
                    </form>
                </SearchPanel>
            </div>
        );
    }
}
